import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, switchMap, tap } from 'rxjs/operators'
import { ConsigneesApiService } from 'src/api/consignees'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import {
  createConsignee,
  createConsigneeFailure,
  createConsigneeSuccess,
  loadConsignees,
  loadConsigneesFailure,
  loadConsigneesSuccess,
  updateConsignee,
  updateConsigneeFailure,
  updateConsigneeSuccess
} from './consignees.actions'

@Injectable()
export class ConsigneesEffects {
  private actions$ = inject(Actions)
  private consignees = inject(ConsigneesApiService)
  private toaster = inject(ToasterService)


  loadConsignees$ = createEffect(() => this.actions$.pipe(
    ofType(loadConsignees),
    switchMap(() =>
      this.consignees.list({limit: Number.MAX_SAFE_INTEGER}).pipe(
        map(r => loadConsigneesSuccess({ consignees: r.data })),
        catchAndLog(this.toaster, 'Unable to fetch consignees', loadConsigneesFailure
      )))))

  createConsignees$ = createEffect(() => this.actions$.pipe(
    ofType(createConsignee),
    tap(() => this.toaster.progress('Creating consignee...')),
    switchMap(action =>
      this.consignees.create(action.consignee).pipe(
        map(r => createConsigneeSuccess({ consignee: r.data })),
        catchAndLog(this.toaster, 'Unable to create consignee', createConsigneeFailure
      )))))

  updateConsignee$ = createEffect(() => this.actions$.pipe(
    ofType(updateConsignee),
    tap(() => this.toaster.progress('Updating consignee...')),
    switchMap(action =>
      this.consignees.update(action.id, action.consignee).pipe(
        map(r => updateConsigneeSuccess({ consignee: r.data })),
        catchAndLog(this.toaster, 'Unable to update consignee', updateConsigneeFailure
      )))))
}
